import SessionEventProto from "../session-event-proto";
import {EntityType} from "../../gd/const/item";

type Expense = {
    id          : ID,
    projectId   : ID,
    taskId?     :ID
}

type Header = {
    expense     : Expense,
    isBulkUpdate: boolean
}

export default class SessionExpenseDelta extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            expense     : sessionEvent.expense,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    process() {

        if (this.isDifferentCompany()) return false;

        gd.modelBus.newUpdate(EntityType.EXPENSE, this.method, this.header.expense.id, this.data, this.header); //this.header
    }
};